import React, { createContext, useContext, useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { SERVICES_DATA } from "../data";

const LanguageContext = createContext(null);

// Static translation dictionary
const TRANSLATIONS = {
  da: {
    // Navigation
    "nav.home": "Hjem",
    "nav.services": "Ydelser",
    "nav.projects": "Referencer",
    "nav.about": "Om os",
    "nav.contact": "Kontakt",
    "nav.getQuote": "Få tilbud",

    // General
    "cta.requestQuote": "Anmod om et projekttilbud",
    "cta.contactConsultation": "Kontakt os for en konsultation",
    "cta.contactTeam": "Kontakt vores team",
    "scroll.explore": "Rul for at udforske",
    "brand.tagline": "Totalentreprise & Tømrerarbejde",
    "brand.subtagline": "Ingeniørmæssig præcision",

    // Home Page
    "home.hero.title": "Professionel totalentreprise og tømrerarbejde til erhvervskunder og byggepladser",
    "home.hero.subtitle": "Vi leverer komplette projektløsninger og tømrerarbejde af høj kvalitet med fokus på struktur, ansvarlighed og rettidig levering.",
    "home.intro.number": "01 / Introduktion",
    "home.intro.title": "Opbygger tillid og kvalitet",
    "home.intro.text": "Vi er en professionel bygge- og tømrervirksomhed, der specialiserer sig i totalentrepriser, tømrerarbejde og byggepladsservice. Vi arbejder tæt sammen med bygherrer, erhvervskunder og partnere for at sikre effektiv projektudførelse, høj kvalitet og fuld gennemsigtighed gennem hele processen.",
    "home.featured.title": "Udvalgte referencer",
    "home.featured.viewAll": "Se alle projekter",
    "home.why.number": "05 / Hvorfor vælge os",
    "home.why.title": "Hvorfor CPH Collective",
    "home.why.subtitle": "Vi bringer struktur, sikkerhed og ingeniørmæssig præcision til ethvert byggeprojekt.",

    // Services Page
    "services.header.tag": "Vores Ekspertise",
    "services.header.title": "Totalentrepriser & Professionelt Tømrerarbejde",
    "services.header.subtitle": "CPH Collective leverer strukturerede byggeydelser af høj kvalitet til erhvervskunder, bygherrer og aktive byggepladser. Vi kombinerer ingeniørmæssig præcision med solidt håndværk.",
    "services.scope.title": "Nøgleområder & Leverancer:",
    "services.standards.title": "Specialiseringer & Standarder:",
    "services.cta.title": "Har du brug for en skræddersyet løsning?",
    "services.cta.text": "Vi specialiserer os i skræddersyet tømrerarbejde, specialinstallationer og komplekse pladsservices. Kontakt vores ingeniørteam for at drøfte dine projektkrav.",

    // Projects Page
    "projects.header.tag": "Vores Portefølje",
    "projects.header.title": "Referencer & Cases",
    "projects.header.subtitle": "CPH Collective har en dokumenteret erfaring med at levere stabile, veludførte løsninger til erhvervsbyggeri, offentlige rum og aktive byggepladser.",
    "projects.filter.label": "Filtrer efter:",
    "projects.filter.all": "Alle",
    "projects.filter.turnkey": "Totalentreprise",
    "projects.filter.carpentry": "Tømrerarbejde",
    "projects.filter.custom": "Specialprojekter",
    "projects.empty": "Ingen projekter fundet, der matcher filteret.",
    "projects.viewDetails": "Se projektdetaljer",
    "projects.cta.title": "Har du et projekt i tankerne?",
    "projects.cta.text": "Lad os drøfte, hvordan CPH Collective kan bringe struktur, ansvarlighed og førsteklasses håndværk til dit næste byggeri.",

    // Project Detail Page
    "project.detail.loading": "Indlæser projektdetaljer...",
    "project.detail.notFound": "Projektet blev ikke fundet",
    "project.detail.back": "Tilbage til referencer",
    "project.detail.specs": "Projektspecifikationer",
    "project.detail.location": "Beliggenhed",
    "project.detail.role": "Rolle",
    "project.detail.type": "Type",
    "project.detail.overview": "Projektoversigt",
    "project.detail.scope": "Udført arbejde",
    "project.detail.cta.title": "Søger du lignende totalentreprise eller tømrerarbejde?",
    "project.detail.cta.text": "Vi leverer professionel projektstyring, koordinering og high-end tømrerarbejde til komplekse erhvervsbyggerier.",

    // About Page
    "about.header.tag": "Om CPH Collective",
    "about.header.title": "Ingeniørmæssig præcision & Håndværk",
    "about.header.subtitle": "Vi er en dansk bygge- og tømrervirksomhed med fokus på kvalitet, ansvarlighed og professionel projektstyring.",
    "about.who.number": "01 / Hvem vi er",
    "about.who.title": "Hvem vi er",
    "about.who.text": "Vi er en dansk bygge- og tømrervirksomhed med fokus på kvalitet, ansvarlighed og professionel projektstyring. Vores tilgang er baseret på klar kommunikation, praktiske løsninger og respekt for tidsplaner og budgetter.",
    "about.who.subtext": "Vores team er struktureret til at fungere problemfrit på aktive, store kommercielle byggepladser. Vi koordinerer med bygherrer, arkitekter og myndigheder for at sikre, at hvert projekt er udviklet til perfektion og leveret til tiden.",
    "about.values.number": "02 / Kerneværdier",
    "about.values.title": "Hvad vi står for",
    "about.why.number": "03 / Hvorfor vælge os",
    "about.why.title": "Hvorfor vælge os",
    "about.why.subtitle": "Vi bringer struktur, sikkerhed og ingeniørmæssig præcision til ethvert byggeprojekt.",

    // Contact Page
    "contact.header.tag": "Forbind med os",
    "contact.header.title": "Start dit projekt",
    "contact.header.subtitle": "Kontakt os for en uforpligtende samtale om dit projekt. Vi rådgiver, koordinerer og udarbejder præcise tilbud baseret på dine behov og projektets omfang.",
    "contact.info.number": "01 / Kontaktoplysninger",
    "contact.info.title": "CPH Collective Hovedkontor",
    "contact.info.address": "Adresse",
    "contact.info.phone": "Telefon",
    "contact.info.email": "E-mail",
    "contact.info.hours": "Åbningstider",
    "contact.form.title": "Projektforespørgsel",
    "contact.form.subtitle": "Udfyld formularen nedenfor for at anmode om et tilbud eller en konsultation.",
    "contact.form.name": "Fuldt navn *",
    "contact.form.company": "Virksomhed",
    "contact.form.email": "E-mailadresse *",
    "contact.form.phone": "Telefonnummer",
    "contact.form.projectType": "Projekttype *",
    "contact.form.message": "Besked / Projektbeskrivelse *",
    "contact.form.files": "Vedhæft filer (valgfrit)",
    "contact.form.dragdrop": "Træk og slip filer her, eller klik for at vælge",
    "contact.form.filelimits": "PDF, PNG, JPEG, GIF, WEBP (Max 5 filer, 10MB pr. fil, 20MB totalt)",
    "contact.form.submitting": "Indsender...",
    "contact.form.submit": "Send forespørgsel",
    "contact.form.success.title": "Forespørgsel indsendt med succes",
    "contact.form.success.text": "Tak fordi du kontaktede CPH Collective. Vores projektstyringsteam vil gennemgå dine krav og vende tilbage til dig inden for 24 timer.",
    "contact.form.error.title": "Fejl ved indsendelse",

    // Footer
    "footer.desc": "Professionelle totalentrepriser og tømrerarbejde af høj kvalitet til erhvervskunder og byggepladser i hele København og på Sjælland.",
    "footer.insured": "Fuldt forsikret",
    "footer.craftsmanship": "Dansk håndværk",
    "footer.delivery": "Levering til tiden",
    "footer.nav": "Navigation",
    "footer.hq": "Hovedkontor",
    "footer.top": "Tilbage til toppen",
    "footer.rights": "Alle rettigheder forbeholdes. Udviklet efter de højeste ingeniørmæssige standarder.",
  },
  en: {
    // Navigation
    "nav.home": "Home",
    "nav.services": "Services",
    "nav.projects": "References",
    "nav.about": "About Us",
    "nav.contact": "Contact",
    "nav.getQuote": "Get Quote",

    // General
    "cta.requestQuote": "Request a project quote",
    "cta.contactConsultation": "Contact us for a consultation",
    "cta.contactTeam": "Contact our team",
    "scroll.explore": "Scroll to explore",
    "brand.tagline": "Turnkey & Carpentry",
    "brand.subtagline": "Engineering Excellence",

    // Home Page
    "home.hero.title": "Professional Turnkey and Carpentry Services for Commercial Clients and Construction Sites",
    "home.hero.subtitle": "We provide complete project solutions and high-quality carpentry work with a focus on structure, accountability, and on-time delivery.",
    "home.intro.number": "01 / Introduction",
    "home.intro.title": "Engineering Trust & Excellence",
    "home.intro.text": "We are a professional construction company specializing in turnkey solutions, carpentry, and on-site construction services. We work closely with developers, commercial clients, and partners to ensure efficient project execution, high quality, and full transparency throughout the entire process.",
    "home.featured.title": "Featured References",
    "home.featured.viewAll": "View all projects",
    "home.why.number": "05 / Why Choose Us",
    "home.why.title": "Why Choose CPH Collective",
    "home.why.subtitle": "We bring structure, safety, and rigorous execution standards to every construction project.",

    // Services Page
    "services.header.tag": "Our Expertise",
    "services.header.title": "Turnkey Solutions & Professional Carpentry",
    "services.header.subtitle": "CPH Collective delivers structured, high-quality construction services for commercial clients, developers, and active construction sites. We combine engineering excellence with premium craftsmanship.",
    "services.scope.title": "Key Scope & Deliverables:",
    "services.standards.title": "Specializations & Standards:",
    "services.cta.title": "Need a Customized Solution?",
    "services.cta.text": "We specialize in tailored carpentry, bespoke installations, and complex site services. Contact our engineering team to discuss your project requirements.",

    // Projects Page
    "projects.header.tag": "Our Portfolio",
    "projects.header.title": "References & Case Studies",
    "projects.header.subtitle": "CPH Collective has a proven track record of delivering stable, well-executed solutions for commercial buildings, public spaces, and active construction sites.",
    "projects.filter.label": "Filter by:",
    "projects.filter.all": "All",
    "projects.filter.turnkey": "Turnkey",
    "projects.filter.carpentry": "Carpentry",
    "projects.filter.custom": "Custom Projects",
    "projects.empty": "No projects found matching the filter.",
    "projects.viewDetails": "View Project Details",
    "projects.cta.title": "Have a Project in Mind?",
    "projects.cta.text": "Let's discuss how CPH Collective can bring structure, accountability, and premium craftsmanship to your next development.",

    // Project Detail Page
    "project.detail.loading": "Loading Project Details...",
    "project.detail.notFound": "Project Not Found",
    "project.detail.back": "Back to References",
    "project.detail.specs": "Project Specifications",
    "project.detail.location": "Location",
    "project.detail.role": "Role",
    "project.detail.type": "Type",
    "project.detail.overview": "Project Overview",
    "project.detail.scope": "Scope of Work Delivered",
    "project.detail.cta.title": "Seeking Similar Turnkey or Carpentry Execution?",
    "project.detail.cta.text": "We provide professional project management, coordination, and high-end carpentry for complex commercial builds.",

    // About Page
    "about.header.tag": "About CPH Collective",
    "about.header.title": "Engineering Excellence & Craftsmanship",
    "about.header.subtitle": "We are a Danish construction and carpentry company with a focus on quality, responsibility, and professional project management.",
    "about.who.number": "01 / Who We Are",
    "about.who.title": "Who We Are",
    "about.who.text": "We are a Danish construction and carpentry company with a focus on quality, responsibility, and professional project management. Our approach is based on clear communication, practical solutions, and respect for timelines and budgets.",
    "about.who.subtext": "Our team is structured to operate seamlessly on active, large-scale commercial construction sites. We coordinate with developers, architects, and municipal authorities to ensure that every project is engineered to perfection and delivered on schedule.",
    "about.values.number": "02 / Core Values",
    "about.values.title": "What We Stand For",
    "about.why.number": "03 / Why Choose Us",
    "about.why.title": "Why Choose Us",
    "about.why.subtitle": "We bring structure, safety, and rigorous execution standards to every construction project.",

    // Contact Page
    "contact.header.tag": "Connect With Us",
    "contact.header.title": "Start Your Project",
    "contact.header.subtitle": "Get in touch for a non-binding conversation about your project. We provide guidance, architectural coordination, and prepare precise quotes based on your needs and project scope.",
    "contact.info.number": "01 / Contact Information",
    "contact.info.title": "CPH Collective HQ",
    "contact.info.address": "Address",
    "contact.info.phone": "Phone",
    "contact.info.email": "Email",
    "contact.info.hours": "Business Hours",
    "contact.form.title": "Project Inquiry",
    "contact.form.subtitle": "Fill out the form below to request a quote or consultation.",
    "contact.form.name": "Full Name *",
    "contact.form.company": "Company",
    "contact.form.email": "Email Address *",
    "contact.form.phone": "Phone Number",
    "contact.form.projectType": "Project Type *",
    "contact.form.message": "Message / Project Description *",
    "contact.form.files": "Attach Files (Optional)",
    "contact.form.dragdrop": "Drag & drop files here, or click to browse",
    "contact.form.filelimits": "PDF, PNG, JPEG, GIF, WEBP (Max 5 files, 10MB per file, 20MB total)",
    "contact.form.submitting": "Submitting...",
    "contact.form.submit": "Send Inquiry",
    "contact.form.success.title": "Inquiry Submitted Successfully",
    "contact.form.success.text": "Thank you for contacting CPH Collective. Our project management team will review your requirements and get back to you within 24 hours.",
    "contact.form.error.title": "Submission Error",

    // Footer
    "footer.desc": "Professional turnkey solutions and high-quality carpentry work for commercial clients and construction sites across Copenhagen and Zealand.",
    "footer.insured": "Fully Insured",
    "footer.craftsmanship": "Danish Craftsmanship",
    "footer.delivery": "On-Time Delivery",
    "footer.nav": "Navigation",
    "footer.hq": "Headquarters",
    "footer.top": "Back to top",
    "footer.rights": "All rights reserved. Developed to the highest engineering standards.",
  }
};

export function LanguageProvider({ children }) {
  const location = useLocation();
  const navigate = useNavigate();
  const [lang, setLang] = useState("da");
  const [projects, setProjects] = useState([]);

  // Detect language based on URL path
  useEffect(() => {
    const isEnglish = location.pathname.startsWith("/en") || location.pathname === "/en";
    setLang(isEnglish ? "en" : "da");
  }, [location.pathname]);

  // Fetch projects to support slug translation
  useEffect(() => {
    const fetchProjects = async () => {
      try {
        const res = await fetch("https://api.dev.auxo.dk/public/v2/content/projects");
        if (res.ok) {
          const data = await res.json();
          setProjects(data.items || []);
        }
      } catch (err) {
        console.error("Error fetching projects for language context:", err);
      }
    };
    fetchProjects();
  }, []);

  // Translation function
  const t = (key) => {
    return TRANSLATIONS[lang]?.[key] || TRANSLATIONS["da"]?.[key] || key;
  };

  // Helper to translate a path to the other language
  const getEquivalentPath = (currentPath, targetLang) => {
    if (targetLang === "da") {
      // Translating from EN to DA
      if (currentPath === "/en" || currentPath === "/en/") return "/";
      if (currentPath.startsWith("/en/services")) {
        const match = currentPath.match(/\/en\/services\/([^/]+)/);
        if (match) {
          const enSlug = match[1];
          const service = SERVICES_DATA.find(s => s.slug?.en === enSlug || s.id === enSlug);
          if (service) {
            return `/ydelser/${service.slug?.da || service.id}`;
          }
        }
        return "/ydelser";
      }
      if (currentPath.startsWith("/en/projects")) {
        // Check if it's a detail page
        const match = currentPath.match(/\/en\/projects\/([^/]+)/);
        if (match) {
          const enSlug = match[1];
          // Find project with this English slug
          const project = projects.find(p => {
            const pSlug = p.project_slug;
            return typeof pSlug === "object" ? pSlug.en === enSlug : pSlug === enSlug;
          });
          if (project) {
            const daSlug = typeof project.project_slug === "object" ? project.project_slug.da : project.project_slug;
            return `/projekter/${daSlug}`;
          }
          return "/projekter";
        }
        return "/projekter";
      }
      if (currentPath.startsWith("/en/about")) return "/om-os";
      if (currentPath.startsWith("/en/contact")) return "/kontakt";
      if (currentPath === "/en/construction-projects") return "/ydelser/byggeprojekt";
      if (currentPath === "/en/total-renovation") return "/ydelser/totalrenovering";
      if (currentPath === "/en/trades-construction-projects" || currentPath === "/en/trades") return "/ydelser/haandvaerker-byggeprojekt";
      return "/";
    } else {
      // Translating from DA to EN
      if (currentPath === "/" || currentPath === "") return "/en";
      if (currentPath.startsWith("/ydelser")) {
        const match = currentPath.match(/\/ydelser\/([^/]+)/);
        if (match) {
          const daSlug = match[1];
          const service = SERVICES_DATA.find(s => s.slug?.da === daSlug || s.id === daSlug);
          if (service) {
            return `/en/services/${service.slug?.en || service.id}`;
          }
        }
        return "/en/services";
      }
      if (currentPath === "/totalentreprise") return "/en/services/turnkey";
      if (currentPath === "/projektering-af-byggeri") return "/en/services/building-engineering";
      if (currentPath === "/toemrerarbejde") return "/en/services/carpentry";
      if (currentPath === "/renovering") return "/en/services/renovation";
      if (currentPath === "/byggepladsservice") return "/en/services/construction-site-services";
      if (currentPath === "/specialprojekter") return "/en/services/custom-projects";
      if (currentPath === "/byggeprojekt") return "/en/services/construction-projects";
      if (currentPath === "/totalrenovering") return "/en/services/total-renovation";
      if (currentPath === "/haandvaerker-byggeprojekt" || currentPath === "/haandvaerker") return "/en/services/trades-construction-projects";
      if (currentPath.startsWith("/projekter")) {
        // Check if it's a detail page
        const match = currentPath.match(/\/projekter\/([^/]+)/);
        if (match) {
          const daSlug = match[1];
          // Find project with this Danish slug
          const project = projects.find(p => {
            const pSlug = p.project_slug;
            return typeof pSlug === "object" ? pSlug.da === daSlug : pSlug === daSlug;
          });
          if (project) {
            const enSlug = typeof project.project_slug === "object" ? project.project_slug.en : project.project_slug;
            return `/en/projects/${enSlug}`;
          }
          return "/en/projects";
        }
        return "/en/projects";
      }
      if (currentPath.startsWith("/om-os")) return "/en/about";
      if (currentPath.startsWith("/kontakt")) return "/en/contact";
      return "/en";
    }
  };

  const changeLanguage = (targetLang) => {
    if (targetLang === lang) return;
    const nextPath = getEquivalentPath(location.pathname, targetLang);
    navigate(nextPath);
  };

  return (
    <LanguageContext.Provider value={{ lang, t, changeLanguage, getEquivalentPath, projects }}>
      {children}
    </LanguageContext.Provider>
  );
}

export function useLanguage() {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error("useLanguage must be used within a LanguageProvider");
  }
  return context;
}
